<template>
  <div>
    <transition name="el-fade-in-linear">
      <div class="main_wrap" v-show="shown.mainshow">
        <div class="commonhead">
          <com-head></com-head>
        </div>
        <div class="head_wrap"></div>
        <div class="body_wrap">
          <div class="cart_content">
            <div class="condition_content">
              <el-form>
                <el-form-item :label="$t('App.page.cart.label_least_total')">
                  <span>{{ pageData.sign }}</span>&nbsp;{{ this.pageData.custUserinfo.minamount }}
                   </el-form-item><el-progress :color="progressColors"
                  :percentage="currentTotal > 100 ? 100 : currentTotal" :format="formatpercentage(currentTotal)"
                  style="width: 20rem"></el-progress>
                <el-form-item :label="$t('App.page.cart.label_least_weight')">{{ this.pageData.custUserinfo.minweight
                }}&nbsp;
                  {{ $t('App.text.kg_abbr') }}</el-form-item>
                <el-progress :color="progressColors" :percentage="currentWeight > 100 ? 100 : currentWeight"
                  :format="formatpercentage(currentWeight)" style="width: 20rem"></el-progress>
                <div class="air_alert_content">
                  <el-alert :title="this.$t('App.page.cart.air_alert')" type="warning" :closable="false"
                    style="margin-top: 2rem; width: 50rem" show-icon effect="dark" v-if="pageData.airFlag">
                  </el-alert>
                </div>
              </el-form>
            </div>

            <div class="table_cart">
              <el-table ref="cartTable" :data="pageData.cartTableData" tooltip-effect="dark" border show-summary
                :summary-method="getSummaries" @selection-change="cartSelectedChange" :header-cell-style="{
                  textAlign: 'center',
                  backgroundColor: '#f2f6fc',
                }" :cell-style="{ textAlign: 'center' }">
                <template slot="empty">
                  <div class="empty_cart">
                    <el-col class="fa fa-shopping-cart fa-4x"></el-col>
                    <font size="3rem">{{
                      this.$t('App.page.cart.empty_cart')
                    }}</font>
                    <router-link :to="{ name: 'Home' }">{{
                      this.$t('App.page.cart.empty_cart_url')
                    }}</router-link>
                  </div>
                </template>
                <el-table-column type="index" width="70"> </el-table-column>
                <el-table-column :label="this.$t('App.page.cart.productimage')">
                  <template slot-scope="scope">
                    <!-- <el-image :src="'data:image/jpg;base64,' + scope.row.img">
                      <div slot="placeholder" class="image-slot">
                        {{ $t('App.text.loading') }}
                      </div>
                    </el-image> -->
                    <el-image v-if="
                      scope.row && scope.row.img && scope.row.img.length > 0
                    " :src="formatProductImage(scope.row.img)" /> </template></el-table-column>
                <el-table-column :label="this.$t('App.page.cart.productname')">
                  <template slot-scope="scope">{{
                    scope.row.productname
                  }}</template>
                </el-table-column>
                <!-- 零售价/单个价 -->
                <el-table-column :label="this.$t('App.page.cart.productprice')">
                  <template slot-scope="scope">{{ scope.row.sign
                    }}{{ Number(scope.row.uniprice).toFixed(2) }}</template>
                </el-table-column>
                <!-- 折扣 -->
                <el-table-column :label="this.$t('App.page.cart.productdiscount')"
                  v-if="pageData.cartTableData.some(it => !it.new_price)">
                  <template slot-scope="scope">
                    <span v-if="scope.row.new_price"></span>
                    <span v-else>{{ Number(scope.row.scount * 100).toFixed() }}%</span>
                  </template>
                </el-table-column>
                <!-- 折扣价 -->
                <el-table-column :label="this.$t('App.page.cart.productdisprice')" width="140"
                  v-if="pageData.cartTableData.some(it => !it.new_price)">
                  <template slot-scope="scope">
                    {{ scope.row.sign
                    }}{{ Number(scope.row.disprice).toFixed(2) }}
                  </template>
                </el-table-column>

                <!-- 显示阶梯 -->
                <el-table-column :label="this.$t('App.page.cart.ladderRange')" width="350" key="ladderRange"
                  v-if="pageData.cartTableData.some(it => it.new_price)">
                  <template slot-scope="scope">
                    <el-steps :active="scope.row.stepActive" align-center finish-status="wait" process-status="finish"
                      v-if="
                        pageData.ladderData &&
                        pageData.ladderData[scope.row.productid] &&
                        scope.row.new_price
                      ">
                      <el-step v-for="(it, index) in pageData.ladderData[
                        scope.row.productid
                      ]" :key="it.title" :title="it.title" :icon="index == scope.row.stepActive
                        ? 'el-icon-circle-check'
                        : 'el-icon-circle-close'
                        ">
                        <template slot="description">
                          <div class="step_description">
                            {{ scope.row.sign }}{{ it.price }}
                          </div>
                        </template>
                        <template slot="title">
                          <div class="step_title">
                            {{ it.title }}
                          </div>
                        </template>
                        <template slot="icon">
                          <div class="step_icon">
                            <i :class="index == scope.row.stepActive
                              ? 'el-icon-circle-check'
                              : 'el-icon-circle-close'
                              "></i>
                          </div>
                        </template>
                      </el-step>
                    </el-steps>
                  </template>
                </el-table-column>

                <!-- 优惠价 -->
                <!-- <el-table-column :label="this.$t('App.page.cart.ladderPrice')" prop="ladderPrice" key="ladderPrice"
                  v-if="pageData.cartTableData.some(it => it.new_price)">
                  <template slot-scope="scope">
                    {{ scope.row.sign
                    }}{{
                      scope.row.ladderPrice &&
                      Number(scope.row.ladderPrice).toFixed(2)
                    }}
                  </template>
                </el-table-column> -->

                <!-- TODO：数量修改 -->
                <el-table-column prop="quantity" :label="this.$t('App.page.cart.productquantity')">
                  <template slot-scope="scope">
                    <span v-if="scope.row.productid === pageData.currentClickId">
                      <el-input-number :min="1" :max="9999" size="mini" v-model="scope.row.quantity"
                        @change="refreshSub(scope.row)" v-if="
                          scope.row.productid == 'PD830215946' ||
                          scope.row.productid == 'PD8302305836' ||
                          scope.row.productid == 'PD3486991625' ||
                          scope.row.productid == 'PD3486995656'
                        " :step="30" step-strictly></el-input-number>
                      <el-input-number :min="1" :max="9999" size="mini" v-model="scope.row.quantity"
                        @change="refreshSub(scope.row)" v-else></el-input-number>
                    </span>
                    <span v-else>{{ scope.row.quantity }}</span>
                  </template>
                </el-table-column>

                <el-table-column prop="subprice" :label="this.$t('App.page.cart.productsubprice')">
                  <template slot-scope="scope">
                    {{ scope.row.sign
                    }}{{ Number(scope.row.subprice).toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column :label="this.$t('App.page.cart.productoption')">
                  <template slot-scope="scope">
                    <el-button type="primary" circle size="mini" v-if="scope.row.productid !== pageData.currentClickId"
                      icon="el-icon-edit" @click="modifyRow(scope.row)"></el-button>
                    <el-button type="success" circle size="mini" v-else icon="el-icon-check"
                      @click="confirmRow(scope.row)"></el-button>

                    <el-button type="danger" circle size="mini" icon="el-icon-delete"
                      @click="cartDeleteRow(scope.$index, scope.row)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="cart_domain">
              <div class="domain_text">
                <span style="
                    color: #303133;
                    font-size: 1rem;
                    vertical-align: middle;
                  ">{{ $t('App.page.cart.text_total') }}</span>
                <span style="color: red; font-size: 1rem; vertical-align: middle"><span
                    v-if="this.pageData.totalPrice !== 0">
                    <span style="font-size: 0.9rem">{{
                      this.pageData.sign
                    }}</span> </span>{{ Number(this.pageData.totalPrice).toFixed(2) }}</span>
                <span style="
                    color: #303133;
                    font-size: 1rem;
                    vertical-align: middle;
                  ">{{ $t('App.page.cart.text_weight') }}</span>
                <span style="color: red; font-size: 1rem; vertical-align: middle">{{
                  Number(this.pageData.totalWeight).toFixed(2)
                }}{{ $t('App.text.kg_abbr') }}</span>
              </div>
              <div class="domain_button">
                <el-button size="mini" type="danger" @click="clearCart"
                  :disabled="pageData.cartTableData.length === 0 ? true : false">{{ $t('App.page.cart.btn_clearcart')
                  }}</el-button>
                <el-tooltip class="item" effect="dark" :content="'Minimum order Amount (MOA) is '+pageData.sign+pageData.custUserinfo.minamount" placement="bottom" 
                  :disabled="pageData.totalPrice >= pageData.custUserinfo.minamount">
                  <el-button size="mini" type="primary" @click="toCheckout" :disabled="pageData.cartTableData.length === 0 ||
                  pageData.totalPrice < pageData.custUserinfo.minamount ||
                  pageData.totalWeight < pageData.custUserinfo.minweight ||
                  pageData.currentClickId != null ||
                  pageData.airFlag
                  ">{{ $t('App.page.cart.btn_checkout') }}</el-button>
                </el-tooltip>
                <!-- <el-button size="mini" type="primary" @click="toCheckout" :disabled="pageData.cartTableData.length === 0 ||
                  pageData.totalPrice < pageData.custUserinfo.minamount ||
                  pageData.totalWeight < pageData.custUserinfo.minweight ||
                  pageData.currentClickId != null ||
                  pageData.airFlag
                  ">{{ $t('App.page.cart.btn_checkout') }}</el-button> -->
                <el-tooltip class="item" effect="dark" :content="$t('App.page.cart.tooltip_refresh_cart')"
                  placement="bottom">
                  <el-button circle icon="el-icon-refresh" type="success" size="mini" @click="_refresh"></el-button>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div class="foot_wrap"><com-foot></com-foot></div>
      </div>
    </transition>
  </div>
</template>

<script>
import Head from '@/components/customer/customerCommonHeader'
import Foot from '@/components/customer/customerCommonFooter'
import * as cartjs from '@/assets/js/cart'
import * as verifyjs from '@/assets/js/verify'
import * as utilsjs from '@/assets/js/utils'

export default {
  data() {
    return {
      api: '',
      shown: {
        mainshow: false,
      },
      pageData: {
        username: '',
        lang: '',
        user: {},
        custUserinfo: {},
        cartSelected: [],
        cartTableData: [],
        discountRules: [],
        totalPrice: 0,
        totalWeight: 0,
        forceUpdateRowQuantityFlag: false,
        currentClickId: null,
        airFlag: true,
        oldRow: {},
        sign: '',
        abbr: '',
      },
      formData: {},
    }
  },
  computed: {
    currentTotal: function () {
      let resultTotal = Number(
        (
          (Number(this.pageData.totalPrice) /
            Number(this.pageData.custUserinfo.minamount)) *
          100
        ).toFixed(),
      )
      if (isNaN(resultTotal)) {
        resultTotal = 0
      }
      if (resultTotal > 100) {
        resultTotal = 100
      }
      return resultTotal
    },
    currentWeight: function () {
      let resultWeight = Number(
        (
          (Number(this.pageData.totalWeight) /
            Number(this.pageData.custUserinfo.minweight)) *
          100
        ).toFixed(),
      )
      if (isNaN(resultWeight)) {
        resultWeight = 0
      }
      if (resultWeight > 100) {
        resultWeight = 100
      }
      return resultWeight
    },
  },
  created() {
    this.$npg.start()
    this.$npg.inc()
  },
  mounted() {
    this.prepareForMounted()
  },
  methods: {
    async prepareForMounted() {
      this.api =
        (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG.API_PREFIX) ||
        process.env.API_PREFIX ||
        ''
      this.$npg.done()
      this.pageData.username = sessionStorage.getItem('username')
      this.pageData.lang = sessionStorage.getItem('lang')

      this.pageData.custUserinfo = JSON.parse(
        sessionStorage.getItem(this.pageData.username),
      )
      this.pageData.discountRules = JSON.parse(
        sessionStorage.getItem('disocunt_rules'),
      )
      if (this.pageData.custUserinfo.region == 1) {
        this.pageData.sign = '￥'
      } else {
        this.pageData.sign = sessionStorage.getItem('cust_sign')
      }
      this.pageData.abbr = sessionStorage.getItem('cust_abbr')

      if (verifyjs.isMounted(this)) {
        document.title = this.$t('App.title.cart')
        this.pageData.user.username = this.pageData.username

        await cartjs.showCart(this, this.pageData.username)

        //启动了获取阶梯价格信息
        if (this.pageData.cartTableData.length > 0) {
          await cartjs.getLadderPriceNew(
            this,
            this.pageData.cartTableData,
            JSON.parse(sessionStorage.getItem(this.pageData.username)).currency,
            this.pageData.username
          )
        }

        setTimeout(() => {
          this.shown.mainshow = true
        }, 1)
      } else {
        this.$router.push({ name: 'Login' })
      }
    },
    formatProductImage(img) {
      if (!img || img.length === 0) return ''
      // If already base64 or full URL, return as is
      if (img.indexOf('data:image') === 0 || img.indexOf('http') === 0) {
        return img
      }
      // If starts with /images, prepend the product image server URL
      if (img.indexOf('/images') === 0) {
        return (process.env.PRODUCT_IMAGE_URL || '') + img
      }
      // Otherwise, prepend API prefix
      return (this.api || '') + img
    },
    _refresh() {
      location.reload()
    },
    cartSelectedChange(val) {
      this.pageData.cartSelected = val
    },
    // 计算购物车总金额和总重量
    getSummaries({ columns, data }) {
      return columns.map((column, index) => {
        if (index === 0) return 'Sum'
        if (column.property === 'quantity') {
          return data.reduce((sum, item) => sum + Number(item.quantity || 0), 0)
        }
        if (column.property === 'subprice') {
          const totalCents = data.reduce( (sum, item) => sum + Math.round(Number(item.subprice || 0) * 100),0, )
          return (totalCents / 100).toFixed(2)
        }
        return ''
      })
    },
    modifyRow(row) {
      this.pageData.currentClickId = row.productid
      this.pageData.oldRow = JSON.parse(JSON.stringify(row))
      row.new_price = row.stagedPrice
    },
    confirmRow(row) {
      if (
        row.productid == this.pageData.oldRow.productid &&
        typeof row.productid != undefined &&
        row.productid != null &&
        row.productid != ''
      ) {
        if (Number(row.quantity) != this.pageData.oldRow.quantity) {
          if (verifyjs.strIsEmpty(row.quantity) || isNaN(row.quantity)) {
            return
          } else {
            this.modifyQuantity(row)
          }
        } else {
          this.pageData.currentClickId = null
          this.pageData.oldRow = null
        }
      }
    },
    cartDeleteRow(index, row) {
      this.pageData.cartTableData.splice(index, 1)
      cartjs.deleteFromCart(this, this.pageData.user, row)
    },
    clearCart() {
      this.$confirm(
        this.$t('App.page.cart.text_clearcartconfirm_body'),
        this.$t('App.page.cart.text_clearcartconfirm_title'),
        {
          confirmButtonText: this.$t('App.page.cart.btn_clearcart_confirm'),
          cancelButtonText: this.$t('App.page.cart.btn_clearcart_cancel'),
          type: 'warning',
        },
      )
        .then(() => {
          this.pageData.cartTableData = []
          cartjs.clearCart(this, this.pageData.username)
          this.pageData.totalPrice = 0
          this.pageData.totalWeight = 0
          this.$message({
            type: 'success',
            message: this.$t('App.page.cart.message_clearcart_delete'),
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('App.page.cart.message_clearcart_cancel'),
          })
        })
    },
    toCheckout() {
      this.$router.push({
        name: 'OrderConfirm',
        params: {
          cartItems: this.pageData.cartTableData,
          totalPrice: this.pageData.totalPrice,
          totalWeight: this.pageData.totalWeight,
        },
      })
    },
    setCurrentQuantity(row, column, cell, event) { },
    modifyQuantity(row, column, cell, event) {
      this.$nextTick(() => {
        if (row.quantity === this.pageData.oldRow.quantity) {
          return
        } else {
          let quantityChange = 0
          quantityChange = row.quantity - this.pageData.oldRow.quantity
          cartjs.modifyQuantityFromCart(
            this,
            this.pageData.user,
            row,
            quantityChange,
          )
        }
      })
    },
    // TODO：未启用新价格体系总计等于数量*折扣价，启用后判断数量在哪个价格区间，然后计算价格
    refreshSub(row) {
      this.$nextTick(() => {
        row.subprice = (row.quantity * row.disprice).toFixed(2)
        if (row.new_price) {
          row = cartjs.getLadderPriceByProductAndQuantity(this, row)
          row.disprice = row.ladderPrice
        }

        //数量变更，重新计算总计和总重
        const { totalPrice, totalWeight } = this.pageData.cartTableData.reduce(
          (acc, item) => {
            acc.totalPrice += Number(item.subprice || 0)
            acc.totalWeight += Number(item.weight) * Number(item.quantity)
            return acc
          },
          { totalPrice: 0, totalWeight: 0 },
        )
        this.pageData.totalPrice = totalPrice
        this.pageData.totalWeight = totalWeight
      })
    },
    forceUpdateRowQuantity() {
      this.pageData.forceUpdateRowQuantityFlag = true
    },
    progressColors(percentage) {
      if (percentage < 100) {
        return '#409eff'
      } else {
        return '#67c23a'
      }
    },
    formatpercentage(percentage) {
      return () => {
        return percentage + '%'
      }
    },
  },
  components: {
    'com-head': Head,
    'com-foot': Foot,
  },
}
</script>

<style scoped>
.head_title {
  color: #606266;
  font-size: 1.1rem;
  text-align: left;
  margin-bottom: 1rem;
  margin-left: 6rem;
}

.main_wrap {
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  position: fixed;
}

.body_wrap {
  width: 100%;
  height: 100%;
  /* border: solid 0.01rem #dcdfe6; */
  padding: 1rem;
  overflow: auto;
}

.tag_quantity {
  text-align: left;
  margin-bottom: 1.5rem;
  margin-left: 9.6rem;
}

.tag_quantity .el-tag {
  font-size: 0.9rem;
}

.cart_content .el-form {
  margin-left: 2rem;
}

.condition_content {
  text-align: left;
  margin-left: 8rem;
  margin-bottom: 2rem;
  color: #67c23a;
}

.condition_content .el-form-item {
  margin-bottom: 0;
}

.table_cart {
  margin-left: 10rem;
  width: 100rem;
  overflow: auto;
}

.table_cart .el-image {
  width: 5rem;
}

.empty_cart {
  padding-top: 3.5rem;
  padding-bottom: 5rem;
}

.empty_cart a {
  text-decoration: none;
  color: #409eff;
}

.empty_cart a:hover {
  color: #76b6f8;
}

.cart_domain {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.domain_text {
  margin-bottom: 2rem;
  width: 30rem;
  text-align: left;
  margin-left: 10rem;
}

.domain_button {
  width: 30rem;
  text-align: left;
  margin-left: 10rem;
}

.step_description {
  position: relative;
  top: -70px;
  font-size: 14px;
}

.step_icon {
  font-size: 19px;
}

.step_title {
  font-size: 14px;
  height: 25px;
  line-height: 25px;
}

/deep/ .el-step__icon.is-icon {
  width: 20px;
}

/deep/ .el-table .cell {
  overflow: visible;
}

/deep/ .el-steps--horizontal {
  margin-top: 20px;
  height: 50px;
}

/deep/ .el-steps .is-wait {
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/views/customer/Cart.vue